import React from 'react';
import SidebarToggleHandler from '../../../../../@coremat/CmtLayouts/Vertical/SidebarToggleHandler';
import Toolbar from '@material-ui/core/Toolbar';
import { Box, InputBase } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import LanguageSwitcher from '../LanguageSwitcher';
import makeStyles from '@material-ui/core/styles/makeStyles';
import SearchIcon from '@material-ui/icons/Search';
import AppsMenu from './AppsMenu';
import HeaderNotifications from './HeaderNotifications';
import HeaderMessages from './HeaderMessages';
import Hidden from '@material-ui/core/Hidden';
import Logo from '../Logo';
import SearchPopover from '../SearchPopover';
import HeaderLogin from './HeaderLogin';
import UserDropDown from '../UserDropDown';
import Input from '@mui/material/Input';

const useStyles = makeStyles(theme => ({
  root: {
  width: '100%',
  paddingLeft: 8,
  paddingRight: 8,
  minHeight: 56,
  [theme.breakpoints.up('sm')]: {
    paddingLeft: 16,
    paddingRight: 16,
    minHeight: 64,
  },
  [theme.breakpoints.up('md')]: {
    paddingLeft: 24,
    paddingRight: 24,
    minHeight: 72,
  },
},
  searchRoot: {
    position: 'relative',
    width: 260,
    [theme.breakpoints.up('md')]: {
      width: 350,
    },
    '& .MuiSvgIcon-root': {
      position: 'absolute',
      left: '32%',
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 1,
      color: '#616161',
    },
    '& .MuiInputBase-root': {
      // width: '60%',
    },
    '& .MuiInputBase-input': {
      height: 48,
      // borderRadius: 30,
      // backgroundColor: alpha(theme.palette.common.dark, 0.38),
      // color: alpha(theme.palette.common.white, 0.7),
      boxSizing: 'border-box',
      padding: '3px 12px 3px 27px',
      transition: 'all 0.3s ease',
      '&:focus': {
        // backgroundColor: alpha(theme.palette.common.dark, 0.58),
        // color: alpha(theme.palette.common.white, 0.7),
      },
    },
  },
  langRoot: {
    borderLeft: `solid 1px ${alpha(theme.palette.common.dark, 0.15)}`,
    minHeight: 72,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 8,
    paddingRight: 8,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      minHeight: 64,
    },
  },
  logoWrap: {
  display: 'flex',
  alignItems: 'center',
  minWidth: 0,
  marginLeft: 0,
  [theme.breakpoints.up('md')]: {
    marginLeft: 16,
  },
  '& img, & svg': {
    maxWidth: '100%',
    maxHeight: 36,
    [theme.breakpoints.up('md')]: {
      maxHeight: 'none',
    },
  },
},
  iconBtn: {
    color: alpha(theme.palette.common.white, 0.38),
    '&:hover, &:focus': {
      color: theme.palette.common.white,
    },
  },
}));

const Header = () => {
  const classes = useStyles();

  return (
    <Toolbar className={classes.root}>
      {/* <SidebarToggleHandler edge="start" color="inherit" aria-label="menu" /> */}
      <Box className={classes.logoWrap}>
  <Logo color="white" />
</Box>
      <Box flex={1} />
      {/* <Hidden smDown>
        <Box pr={3} sx={{ display: 'flex', justifyContent: 'end' }} className={classes.searchRoot}>
          <InputBase placeholder={'Search here...'} inputProps={{ 'aria-label': 'search' }} />
          <Input placeholder="Global search..." inputProps={{ 'aria-label': 'search' }} />
          <SearchIcon />
        </Box>
      </Hidden> */}
      {/* <Hidden mdUp>
        <SearchPopover iconClassName={classes.iconBtn} />
      </Hidden> */}
      {/* <AppsMenu /> */}
      {/* <HeaderMessages /> */}
      <HeaderNotifications />
      {/* <HeaderLogin /> */}
      {/* <Box className={classes.langRoot}>
        <LanguageSwitcher />
      </Box> */}
      <UserDropDown />
    </Toolbar>
  );
};

export default Header;
